
  import { defineComponent, PropType } from 'vue';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';

  import type { TFilterActionButton } from './types/filter';

  export default defineComponent({
    name: 'FilterActions',
    components: { ButtonComponent },
    props: {
      // Кнопки задаются конфигами-объектами (обычно вычисляемыми в родителе).
      actions: {
        type: Array as PropType<TFilterActionButton[]>,
        default: () => [],
      },
      align: {
        type: String as PropType<'start' | 'end' | 'between'>,
        default: 'start',
        validator: (value: string) => ['start', 'end', 'between'].includes(value),
      },
    },
    computed: {
      visibleActions(): TFilterActionButton[] {
        return this.actions.filter((action) => action.isVisible !== false);
      },
    },
  });
